import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installApiHostRewriter } from "@/lib/apiHost";

// Rewrite API calls to the visitor's origin when the app is served from a
// different host than REACT_APP_BACKEND_URL (e.g. custom domain fastprototype.ai
// pointing at the same cluster as the preview URL).
installApiHostRewriter();

const rootElement = document.getElementById("root");

// When the initial HTML was produced by react-snap (build-time pre-render),
// `rootElement` already contains rendered markup — we hydrate instead of
// rendering from scratch so React reuses the DOM the crawler saw.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

